export function equalDates(first: Date, second: Date) {
    const f = new Date(first);
    f.setHours(0, 0, 0, 0);
    const s = new Date(second);
    s.setHours(0, 0, 0, 0);
    return f.getTime() === s.getTime();
}

export function ISODateString(date: Date) {
    return date
        ? `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
        : undefined;
}

export function dayString(value: Date) {
    if (!(value instanceof Date)) return '';

    return value.toLocaleDateString('no-NO', { weekday: 'long' });
}
